import React from 'react'
import { AnyFunction, TypeGuards } from '@codeleap/types'
import { LessonPrimaryCTA, Prompt } from '@/types'
import { Button } from '@/components'
import { ContributeButton } from '../atoms'

const buttonTitles: Record<LessonPrimaryCTA['type'], string> = {
  contribute: 'Respond',
  external_link: 'Continue learning',
  lesson: 'Go to next lesson',
  prompt: 'Respond'
}

type Props = LessonPrimaryCTA & {
  strategy: AnyFunction
}

export function PrimaryCTA(props: Props) {
  const { description: _description, title: _title, prompt: _prompt = {} as Prompt, type, strategy } = props

  const title = _prompt?.title ?? _title
  const description = _prompt?.description ?? _description
  const buttonProps = {
    prompt: { ..._prompt, title, description },
    onPress: strategy,
    text: buttonTitles[type]
  }

  if (TypeGuards.isNil(type)) return null
  if (['contribute', 'prompt'].includes(type)) {
    return <ContributeButton {...buttonProps} />
  }
  return (
    <Button
      debugName={type}
      {...buttonProps}
      variants={['iconSize:2']}
      rightIcon={type === 'external_link' ? 'external-link' : null}
    />
  )
}
